import { v4 as uuidv4 } from 'uuid';
import { CurrencySymbols } from "../types/ui";
import { currencySymbols } from "./dummy";

export function transformString(val: string): string {    
    if (typeof val !== 'string' || !val) return '';

    const value = val.replace(/([A-Z]+)*([A-Z][a-z])/g, '$1 $2');
    
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function transformSnakeCase (val: string): string {
    const result = val.replace(/\s+|_+/g, ' ');
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
}

export function stringToCamelCase(val: string) {
    if (!val || typeof val !== 'string') return '';

    const modifiedVal = val.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      }).replace(/\s+/g, "");
    
    return modifiedVal;
}

export function objectIsEmpty (obj: object): boolean {
    if (!Boolean(obj)) {
      return true;
    }
    if (Object.keys(obj).length === 0) {
      return true;
    }
    return false
};

export function formatDateStringsToDate(date: string): Date | undefined {
  const modifiedDate = new Date(date);

  if (modifiedDate.toLocaleDateString() === "Invalid Date") return;
  
  return modifiedDate;
}

export function formatDateToStrings(date: Date | string, isStandardFormat:boolean = false): string {  
  if (!!isStandardFormat && typeof date === 'string') {
    const usefulDateString = date.split(" ")[0];
    const modifiedDate = new Date(usefulDateString).toLocaleDateString();
    
    if (modifiedDate === 'Invalid Date') return 'N/A'
    return modifiedDate
  }
  
  return new Date(date).toLocaleDateString()
}

export function formatDateToReadableString(date: Date | string) {
  const value = (date instanceof Date) ? date : new Date(date);

  const seconds = Math.floor((new Date().getTime() - new Date(value).getTime()) / 1000)
  let interval = seconds / 31536000;

  const rtf = new Intl.RelativeTimeFormat("en", { numeric: 'auto' });

  if (interval > 1) { 
    return rtf.format(-Math.floor(interval), 'year') 
  }
  
  interval = seconds / 2592000

  if (interval > 1) { 
    return rtf.format(-Math.floor(interval), 'month') 
  }

  interval = seconds / 86400

  if (interval > 1) {
     return rtf.format(-Math.floor(interval), 'day') 
    }
  interval = seconds / 3600

  if (interval > 1)
   { return rtf.format(-Math.floor(interval), 'hour') 
  }
  interval = seconds / 60

  if (interval > 1) { 
    return rtf.format(-Math.floor(interval), 'minute') 
  }

  return rtf.format(-Math.floor(interval), 'second')
}

export function formatDateToReadableShortString(date: Date | string): string {
  const value = (date instanceof Date) ? date : new Date(date);

  const dateTimeFormat = new Intl.DateTimeFormat('en', {
    day: 'numeric', 
    month: 'short',
    year: 'numeric', 
    hour: 'numeric',
    minute: 'numeric'
  });
  
  return dateTimeFormat.format(value);
}

export function getCurrencySymbol(currency: CurrencySymbols) {
  if (!currency) return 'N/A'
  return currencySymbols[currency]
}

export function createRandomUuid(): string {
  return uuidv4()
}